export default class ReasonsSerializer {
  static reasonDeserialize(data){
    return{
      descr: data.descr,
      id: data.id,
      is_active: data.is_active,
      __type: data.__type,
      company_id: data.company_id
    };
  }
  
  static deSerialize(data) {
    return {
      reasons: data.reasons.map(r => this.reasonDeserialize(r))
    };
  }
}